import { lazy } from "react"

// dashboard pages
const Map = lazy(() => import("./pages/dashboard/Map"))
const HeatMap = lazy(() => import("./pages/dashboard/heatMap/HeatMap"))
const ShopRanking = lazy(() => import("./pages/dashboard/ShopRanking"))
const ShopStock = lazy(() => import("./pages/dashboard/ShopStock"))
const TopProductGroups = lazy(() => import("./pages/dashboard/TopProductGroups"))
const YearlySaleSummary = lazy(() => import("./pages/dashboard/yearlySale/Summary"))
const YearlySaleShop = lazy(() => import("./pages/dashboard/yearlySale/Shop"))
const YearlySaleBrand = lazy(() => import("./pages/dashboard/yearlySale/Brand"))
const YearlySaleProductGroup = lazy(() => import("./pages/dashboard/yearlySale/ProductGroup"))
const YearlySaleTopProductGroup = lazy(() => import("./pages/dashboard/yearlySale/TopProductGroup"))
const YearlySaleProductFamily = lazy(() => import("./pages/dashboard/yearlySale/ProductFamily"))

// admin pages
const User = lazy(() => import("./pages/admin/User"))

export const dashboardRoutes = [
  { path: "/heat-map", element: HeatMap },
  { path: "/map", element: Map },
  { path: "/shop-ranking", element: ShopRanking },
  { path: "/shop-stock", element: ShopStock },
  { path: "/top-product-groups", element: TopProductGroups },
  { path: "/yearly-sale/summary", element: YearlySaleSummary },
  { path: "/yearly-sale/shop", element: YearlySaleShop },
  { path: "/yearly-sale/brand", element: YearlySaleBrand },
  { path: "/yearly-sale/product-group", element: YearlySaleProductGroup },
  { path: "/yearly-sale/top-product-group", element: YearlySaleTopProductGroup },
  { path: "/yearly-sale/product-family", element: YearlySaleProductFamily }
]

export const adminRoutes = [{ path: "/admin/users", element: User }]
